import React, { useEffect } from "react";
import Hero from "../Components/Hero";
import aboutImg from "../Assets/about_1.png";
import "../Styles/About.css";
import { useLocation } from "react-router-dom";

function About() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <div className="about_container1">
        <Hero link="Home" pageName="About PyLoan" />
      </div>
      <main className="about_containerdf">
        <div className="scontainer">
          <div className="row align_center">
            <div
              data-aos="fade-right"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-easing="ease-in-out"
              className="col-xl-5 col-md-6 col-sm-12"
            >
              <img src={aboutImg} alt="People reviewing financial information" />
            </div>
            <div
              data-aos="fade-left"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-easing="ease-in-out"
              className="col-xl-7 col-md-6 col-sm-12"
            >
              <div className="about_content">
                <p className="exp_super_title">About PyLoan</p>
                <h1 className="exp_title">
                  Loan information you can verify and use responsibly
                </h1>
                <p className="exp_sub_title">
                  PyLoan is an independent informational website that publishes
                  educational content about loans, government-supported finance
                  schemes, eligibility criteria, documentation, application
                  procedures and repayment considerations. Our aim is to make
                  complex loan-related information easier to understand so
                  readers can make informed enquiries with the relevant bank or
                  official authority.
                </p>
                <p className="exp_desc">
                  PyLoan is not a bank, NBFC, lender or financial institution.
                  We do not provide, sanction, process, arrange, broker or
                  guarantee loans. We do not connect loan applicants with
                  lenders, submit loan applications on behalf of users, collect
                  or forward loan leads, or receive lender referral commissions.
                  Our website is for general educational purposes only.
                </p>

                <div className="about_info">
                  <div className="about_circle">
                    <i className="fa-solid fa-book-open" aria-hidden="true"></i>
                  </div>
                  <div className="about_info_text">
                    <h3>What we publish</h3>
                    <p>
                      Plain-language guides about common loan terms, scheme
                      categories, eligibility factors, documents and questions
                      readers may want to ask an official authority.
                    </p>
                  </div>
                </div>
                <div className="about_info">
                  <div className="about_circle">
                    <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
                  </div>
                  <div className="about_info_text">
                    <h3>Verify before taking action</h3>
                    <p>
                      Scheme rules, eligibility conditions, interest rates,
                      subsidy rates, required documents and application
                      procedures can change. Verify the latest information on
                      the official government portal or with the relevant bank.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section className="about_information_notice">
            <h2>Important information</h2>
            <p>
              PyLoan is not affiliated with any bank, NBFC or government
              authority unless explicitly stated and independently verifiable.
              We do not accept or process loan applications. Do not send OTPs,
              passwords, bank login credentials or full card details through the
              website.
            </p>
          </section>
        </div>
      </main>
    </>
  );
}

export default About;
